// extracted by mini-css-extract-plugin
module.exports = {"controller":"Switch_controller__X32v9","box":"Switch_box__FDESE","active":"Switch_active__SPDIw"};